import React, {
  useState,
  useCallback,
  createContext,
  useContext,
} from 'react';

const EditProfileContext = createContext({});

const useEditProfile = () => useContext(EditProfileContext);

function EditProfileProvider(props) {
  const [editProfileInfo, setEditProfileInfoInternal] = useState({});

  // Stable identity so consumers can list it as an effect dependency without
  // re-running the effect on every provider render. Accepts a value or an
  // updater function, like a useState setter.
  const setEditProfileInfo = useCallback((value) => {
    setEditProfileInfoInternal(value);
  }, []);

  return (
    <EditProfileContext.Provider
      value={{
        setEditProfileInfo,
        editProfileInfo,
      }}
      {...props}
    />
  );
}

export {
  EditProfileProvider,
  useEditProfile
};
